export enum AuthorityAction {
    TRANSFER_TO_PAPER,
    UPDATE_STATUS
}